package es.subastia.data.model

enum class AuctionTypeDataModel(val id: String, val text: String, val boeCode: String) {
    Inmuebles("inmuebles", "Inmuebles", "I"),
    Vehiculos("vehiculos", "Vehículos", "V"),
    Otros("otros", "Otros bienes muebles", "M");

    companion object {
        fun fromString(text: String): AuctionTypeDataModel? {
            return entries.find { it.text.equals(text, ignoreCase = true) || it.id.equals(text, ignoreCase = true) }
        }
    }
}
